import { render, staticRenderFns } from "./loyalty-progress-bar.vue?vue&type=template&id=4c7add38&scoped=true"
import script from "./loyalty-progress-bar.vue?vue&type=script&lang=ts&setup=true"
export * from "./loyalty-progress-bar.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./loyalty-progress-bar.vue?vue&type=style&index=0&id=4c7add38&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c7add38",
  null
  
)

export default component.exports